<div id="loading-content" style="text-align: center;">
  <div id="vertical-separator"></div>
  <div>
    <span class="custom-span"><b>{{ "MESSAGE.COPIED" | translate }}!</b></span>
  </div>
  <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
  </div>
</div>
